import axios from 'axios';

const pollActions = (dispatch) => {
  return {
    loadPoll: (id) => {
      dispatch({ type: 'POLL_LOAD' });
      axios
        .get(`/api/visitor/polls/${id}`)
        .then((response) => {
          if (response.data) {
            dispatch({ type: 'POLL_SUCCESS', poll: response.data });
          } else {
            dispatch({ type: 'POLL_ERROR', error: 'Wrong format' });
          }
        })
        .catch((error) => {
          dispatch({ type: 'POLL_ERROR', error: error });
        });
    },
    loadPollWithAnswer: (id) => {
      dispatch({ type: 'POLL_LOAD' });
      axios
        .get(`/api/visitor/answerpolls/${id}`)
        .then((response) => {
          if (response.data) {
            dispatch({ type: 'POLL_SUCCESS', poll: response.data });
          } else {
            dispatch({ type: 'POLL_ERROR', error: 'Wrong format' });
          }
        })
        .catch((error) => {
          dispatch({ type: 'POLL_ERROR', error: error });
        });
    },
    postAnswer: (id, data, callback) => {
      dispatch({ type: 'POLL_POST_ANSWER' });
      axios
        .post(`/api/visitor/polls/${id}/answer`, { data: data })
        .then((response) => {
          if (response.data) {
            // Wait for socket
            dispatch({
              type: 'POLL_POST_ANSWER_SUCCESS',
              answer: response.data,
            });
            callback();
          } else {
            dispatch({ type: 'POLL_POST_ANSWER_ERROR', error: 'Wrong format' });
          }
        })
        .catch((error) => {
          dispatch({ type: 'POLL_POST_ANSWER_ERROR', error: error });
        });
    },
  };
};
export default pollActions;
